import styled from 'styled-components';

/** No inset of its own: the tab strip above and the section cards below carry the rhythm. */
export const TabWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionCard = styled.section`
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const SectionHeader = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px;
  border-bottom: ${({ $expanded, theme }) => ($expanded ? `1px solid ${theme.palette.divider}` : 'none')};
`;

// margin-left rather than the header's `space-between`: an unscored template renders an empty score
// chip, and `space-between` then pushed the title into the middle of the row.
export const SectionTitle = styled.h2`
  margin: 0 auto 0 0;
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.dark};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 64px 24px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  padding: 2px;
  margin-right: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.secondary};

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;
